class ProductCardGallery extends window.BAO.CustomElement() {
  connectedCallback () {
    if (!this.els.slide || this.els.slide.elements.length < 2) return

    this.setupListeners()
    if (window.innerWidth > 999) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    this.listeners.add(window, 'resize', this.carouselSwitcher.bind(this))

    this.listeners.add(document, 'clcSwitchActivated', this.resetCarousel.bind(this))
  }

  resetCarousel () {
    if (this.carousel) {
      this.carousel.destroy()
      this.carousel = null
      this.els.slides.element.classList.remove('keen-slider')
      this.els.slide.elements.forEach(el => el.classList.remove('keen-slider__slide'))
      this.carousel = this.setupCarousel()
    }
  }

  carouselSwitcher () {
    if (window.innerWidth > 999 && this.carousel) {
      this.carousel.destroy()
      this.carousel = null
      this.els.slides.element.classList.remove('keen-slider')
      this.els.slide.elements.forEach(el => el.classList.remove('keen-slider__slide'))
    } else if (window.innerWidth < 1000 && !this.carousel) {
      this.carousel = this.setupCarousel()
    }
  }

  setupCarousel () {
    const carouselReveal = this.els.slides.element.classList.contains('prd-Card_MediaImages-reveal')
    const carouselNotDraggable = this.els.slides.element.classList.contains('prd-Card_MediaImages-notDraggable')
    this.els.slides.element.classList.add('keen-slider')
    this.els.slide.elements.forEach(el => el.classList.add('keen-slider__slide'))

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        drag: carouselNotDraggable !== true,
        slides: {
          perView: 1,
          spacing: 0,
        },
      },
      [
        window.BAO.carousel.useInitialised(),
        window.BAO.carousel.useDots(this.els?.dot?.elements),
        carouselReveal ? window.BAO.carousel.useReveal(this.els?.slide?.elements) : null,
      ].filter(Boolean),
    )
  }
}

if (!customElements.get('product-card-gallery')) {
  customElements.define('product-card-gallery', ProductCardGallery)
}
